import { format } from 'date-fns';
import capitalize from 'lodash/capitalize';
import first from 'lodash/first';
import last from 'lodash/last';
import { CounterpartInfo } from '~/types/document';
import { compareMoney } from '~/utils/money';

interface DataPoint {
  month: number;
  year: number;
}

export const getPeriodLabel = (period: DataPoint[]): string => {
  const firstMonth = first(period);
  const lastMonth = last(period);
  if (!firstMonth || !lastMonth) {
    return '—';
  }

  const start = capitalize(format(new Date(firstMonth.year, firstMonth.month - 1, 1), 'MMM'));
  const end = capitalize(format(new Date(lastMonth.year, lastMonth.month - 1, 1), 'MMM'));
  return `${start}/${end}`;
};

export const getPeriodLabelLong = (period: DataPoint[]): string => {
  const firstMonth = first(period);
  const lastMonth = last(period);
  if (!firstMonth || !lastMonth) {
    return '—';
  }

  const start = capitalize(format(new Date(firstMonth.year, firstMonth.month - 1, 1), 'MMM'));
  const end = capitalize(format(new Date(lastMonth.year, lastMonth.month - 1, 1), 'MMM'));
  return `${start}/${end} ${firstMonth.year}`;
};

export const formatMonthLabel = (dataPoint: DataPoint): string => {
  return capitalize(format(new Date(dataPoint.year, dataPoint.month - 1, 1), 'MMM'));
};

export const formatMonthLabelLong = (dataPoint: DataPoint): string => {
  return capitalize(format(new Date(dataPoint.year, dataPoint.month - 1, 1), 'MMMM yyyy'));
};

export const sortCounterpartSummary = (counterparts: CounterpartInfo[]): CounterpartInfo[] => {
  return [...counterparts].sort((left, right) => {
    if (left.amountPercentage !== right.amountPercentage) {
      return right.amountPercentage - left.amountPercentage;
    }

    return compareMoney(right.amount, left.amount);
  });
};
